var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"sam-image",style:(_vm.cssStyle),attrs:{"data-samora":""},domProps:{"innerHTML":_vm._s(require(`../../../images/${_vm.image}.svg`))}},'div',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }